module.exports = __webpack_public_path__ + "img/wechat.3b447177.png";